// create an angular service to detect if app is online or offline
import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class NetworkService {
    private status = new BehaviorSubject<boolean>(true);
    private currentStatus = undefined;
    constructor() {
        this.init();
    }
    private async init() {
        const status = await Network.getStatus();
        this.currentStatus = status.connected;
        this.status.next(status.connected);
        Network.addListener('networkStatusChange', (status) => {
            this.status.next(status.connected);
            this.currentStatus = status.connected;
        });
    }
    getStatus() {
        return this.status.asObservable();
    }
    getCurrentStatus() {
        return this.currentStatus;
    }
}
